import { createFeatureSelector, createSelector } from '@ngrx/store';
import { PlantListUserGuidState } from './plant-list-userguid.models';

export const selectPlantListUserGuidState = createFeatureSelector<PlantListUserGuidState>('plantListUserGuid');

export const selectPlantListUserGuid = (userGuid: string) =>
  createSelector(selectPlantListUserGuidState, (state) => state.plants?.[userGuid]);

export const selectPlantListUserGuidLoading = createSelector(selectPlantListUserGuidState, (state) => state.loading);

export const selectPlantListUserGuidError = createSelector(selectPlantListUserGuidState, (state) => state.error);
